import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { createContext, useContext, useMemo } from "react";
//Limitless imports
import { useDevLogging } from "../dev-logging/DevLoggingContext";
import { usePlatformResource } from "./PlatformResourceHook"; // Set the default state values for each context

var PlatformResourceContext = createContext({});
export var PlatformResourceContextProvider = function PlatformResourceContextProvider(_ref) {
  var children = _ref.children,
      resourceList = _ref.resourceList,
      applicationName = _ref.applicationName,
      defaultContentMap = _ref.defaultContentMap,
      delayResourcesAPICall = _ref.delayResourcesAPICall,
      previousLocale = _ref.previousLocale;
  var hook = usePlatformResource(resourceList, applicationName, defaultContentMap, delayResourcesAPICall, previousLocale);

  var _useDevLogging = useDevLogging(),
      stateTracker = _useDevLogging.stateTracker;

  var resourceContext = useMemo(function () {
    stateTracker.trackState({
      resources: _objectSpread({}, hook.resources, {
        resourceList: resourceList
      })
    });
    return _objectSpread({}, hook);
  }, [hook.resources]);
  return /*#__PURE__*/React.createElement(PlatformResourceContext.Provider, {
    value: resourceContext
  }, children);
};
export var useResources = function useResources() {
  return useContext(PlatformResourceContext);
};